// @flow

export function wait(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function toError(value: mixed): Error {
  if (value instanceof Error) return value;
  return new Error(String(value));
}

export function getRetryDelay(baseMs: number, attempt: number): number {
  return baseMs * (attempt + 1); // Linear backoff: 1s, 2s, 3s, …
}
